<template>
  <div>
    <v-card>
      <v-data-table
        dense
        :headers="headers"
        :items="users_winners"
        :options.sync="pagination"
        :server-items-length="totalDesserts"
        :footer-props="{
          'items-per-page-options': [25, 50, 100],
        }"
        :loading="loading"
        loading-text="Считываем данные ..."
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <!-- <v-toolbar-title>Расчеты сотрудников</v-toolbar-title> -->
            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
            <!-- <v-spacer></v-spacer> -->
            <div class="grids">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Найти"
                hide-details
                clearable
              />
              <v-select
                v-model="selectedUser"
                :items="userList"
                item-text="user_name"
                item-value="user_id"
                label="Сотрудник"
              />
            </div>
          </v-toolbar>
          <v-card>
            <alert
              alertType="error"
              :alertData="err"
              caption="Не корректные ИНН"
              @onClose="err = []"
              closed
            />
            <alert
              alertType="info"
              :alertData="info"
              caption="Идет проверка по этим ИНН"
              @onClose="info = []"
            />
            <alert
              alertType="success"
              :alertData="successAdded"
              caption="Успешно добавленные ИНН"
              @onClose="successAdded = []"
            />
            <alert
              alertType="warning"
              :alertData="errorAdded"
              caption="Уже существуют ИНН"
              @onClose="errorAdded = []"
              closed
            />
          </v-card>
        </template>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td>{{ item.inn }}</td>
              <td>{{ item.name }}</td>
              <!-- <td>{{ item.region }}</td> -->
              <td>{{ item.address }}</td>
              <td>{{ item.user_name }}</td>
              <td>
                {{ moment(item.created_at).format("DD.MM.YYYY HH:mm:ss") }}
              </td>
              <td>
                <v-icon @click="removeWinner(item.id)">fa fa-trash</v-icon>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import alert from "@/components/alert.vue";
import moment from "moment";

export default {
  components: { alert },
  data: () => ({
    moment,
    userList: [],
    search: "",
    selectedUser: null,
    winners: [],
    inn: "",
    btn_active: true,
    totalDesserts: 0,
    options: {
      page: 1,
      itemsPerPage: 100,
    },
    pagination: {
      page: 1,
      itemsPerPage: 100,
      sortBy: ["name"],
    },
    loading: false,
    show: false,
    headers: [
      {
        text: "ИНН",
        align: "left",
        filterable: true,
        sortable: true,
        value: "inn",
      },
      {
        text: "Наименование победителя",
        align: "left",
        filterable: true,
        sortable: true,
        value: "name",
      },
      // {
      //   text: "Регион",
      //   align: "left",
      //   filterable: true,
      //   sortable: true,
      //   value: "region",
      // },
      {
        text: "Адрес",
        align: "center",
        filterable: false,
        sortable: false,
        value: "address",
      },
      {
        text: "Пользователь",
        align: "center",
        filterable: true,
        sortable: true,
        value: "user_name",
      },
      {
        text: "Дата добавления",
        align: "center",
        filterable: true,
        sortable: true,
        value: "created_at",
        width: "200px",
      },
      {
        text: "Действия",
        align: "center",
        filterable: false,
        sortable: false,
        width: "40px",
      },
    ],
    err: [],
    info: [],
    errorAdded: [],
    successAdded: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getUsersWinners();
      },
      deep: true,
    },
    search() {
      this.getUsersWinners();
    },
    selectedUser() {
      this.getUsersWinners();
    },
  },
  methods: {
    async init() {
      const users = await this.getUsersList();
      const uniqNames = new Array();
      uniqNames.unshift({ user_id: null, user_name: "Без фильтра" });

      for (const user of users) {
        if (Number(user.user_id) !== Number(this.$store.getters.user_id)) {
          uniqNames.push({
            user_id: user.user_id,
            user_name: user.fio
              ? user.fio
              : user.profile_name
              ? user.profile_name
              : user.name,
          });
        }
      }

      this.userList = uniqNames;
    },
    async removeWinner(id) {
      const data = await this.$store.dispatch("removeWinner", {
        id,
        user_id: this.user_id,
      });
      data && this.getUsersWinners();
    },
    async getUsersWinners() {
      this.loading = true;
      const data = await this.$store.dispatch("getUsersWinners", {
        user_id: this.user_id,
        selectedUser: this.selectedUser,
        search: this.search ? this.search : "",
        pagination: this.pagination,
      });
      this.totalDesserts = data.total;
      const sortBy = [];
      sortBy.push(data.sort.sortBy);
      const sortDesc = [];
      sortDesc.push(data.sort.sortDesc);
      (this.options = {
        page: data.winners.current_page,
        itemsPerPage: data.winners.per_page,
        sortBy,
        sortDesc,
      }),
        (this.winners = data.winners.data);
      this.loading = false;
    },
    async checkInnAdd() {
      this.loading = true;
      const DadataRespondByListCheck = async (list, normal) => {
        const arr = [];
        for (let index in list.result) {
          if (
            list.result[index].err === undefined &&
            list.result[index].name !== null
          ) {
            const toUser = {
              inn: list.result[index].inn,
              name: list.result[index].name,
              address: list.result[index].address
                ? list.result[index].address
                : "Нет данных по адресу",
              region: list.result[index].region
                ? list.result[index].region
                : "Нет данных по региону",
              user_id: this.user_id,
            };
            arr.push({ ...toUser }); // new versions
          } else {
            this.err.push(list.result[index].inn);
          }
        }
        const data = await this.$store.dispatch("setWinnersList", arr);
        data.addData.map((item) => {
          this.successAdded.push(item.inn);
        });
        data.errData.map((item) => {
          this.errorAdded.push(item.data.inn);
        });
      };
      this.btn_active = false;
      this.err = [];
      this.errorAdded = [];
      this.successAdded = [];
      const reg_inn_IP = /^([0-9]{12})$/;
      const reg_inn_JL = /^([0-9]{10})$/;
      let inn = this.inn.split(/\D/);
      const normal = [];
      inn.map((item) =>
        reg_inn_IP.test(item)
          ? normal.push(item)
          : reg_inn_JL.test(item)
          ? normal.push(item)
          : item.length !== 0 && this.err.push(item)
      );
      this.info = [...normal];

      await DadataRespondByListCheck(
        await this.$store.dispatch("checkInnList", normal),
        normal
      );

      this.info = [];
      setTimeout(() => {
        this.successAdded = [];
      }, 5000);
      setTimeout(() => {
        this.getUsersWinners();
      }, 1000);

      this.loading = false;
      this.btn_active = true;
      this.inn = "";
    },
  },
  computed: {
    users_winners: {
      get() {
        return this.winners;
      },
      set(val) {
        this.winners = val;
      },
    },
    user_id: {
      get() {
        return this.$store.getters.user_id;
      },
    },
  },
  mounted() {
    // this.getUsersWinners();
    this.init();
  },
};
</script>

<style lang="scss">
.grids {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
}
</style>
